import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {UtilService} from '../../../../../../shared/_services/util.service';
import {HcaMemberService} from '../../../../../../shared/_services/hca-member.service';
import {ActivatedRoute} from '@angular/router';
import {ValidationService} from '../../../../../../shared/_services/validation.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {Subject} from 'rxjs/Subject';
import {Location} from '@angular/common';
import {StatusModalComponent} from '../../../../../modals/status-modal/status-modal.component';

@Component({
  selector: 'app-members-details',
  templateUrl: './members-details.component.html',
  styleUrls: ['./members-details.component.scss']
})
export class MembersDetailsComponent implements OnInit {
  memberForm: FormGroup;
  previousRoute: any;
  memberDetails: any;
  memberId: number;
  memberRulesList: any;
  statusModal: BsModalRef;
  private unsubscribe: Subject<void> = new Subject<void>();
  minDate: any;
  bsValue: any;
  bsConfig: any;
  errorMsg: any;
  successMsg: any;

  constructor(
    private fb: FormBuilder,
    private location: Location,
    private route: ActivatedRoute,
    private utilService: UtilService,
    private modalService: BsModalService,
    private validationService: ValidationService,
    private hcaMemberService: HcaMemberService
  ) {
    this.modalService.onHide
      .takeUntil(this.unsubscribe)
      .subscribe(() => {
        if (this.statusModal) {
          if (this.statusModal.content.srcObject.action === 'action1') {
            if (this.statusModal.content.srcObject.type === 'member') {
              if (this.statusModal.content.srcObject.status || this.statusModal.content.srcObject.status === 0) {
                const status = +this.statusModal.content.srcObject.status;
                this.activateOrDeactivateMember(this.statusModal.content.srcObject.id, status,
                  this.statusModal.content.srcObject.duplicatedEmailId);
              } else {
                this.location.back();
                this.hcaMemberService.memberDetails = null;
              }
            }
          }
        }
      });
  }

  activateOrDeactivateMember(memberIds, status, duplicatedEmailId) {
    console.log(` employee ${JSON.stringify(memberIds)} was selected to ${status}`);
    this.hcaMemberService.activateOrDeactivateMembers(memberIds, status, duplicatedEmailId).subscribe(res => {
      if (res.error === 0) {
        this.location.back();
      }
    }, err => {
      console.error('Error Activating/Deactivating Employee: ', err.message);
    });
  }

  getMemberDetails(memberId) {
    this.hcaMemberService.getByMemberInfoById(memberId).subscribe(res => {
      if (res.error === 0) {
        this.memberDetails = res.responseObj;
        this.hcaMemberService.memberInformation = this.memberDetails;
        this.initForm(this.memberDetails);
      }
    }, err => {
      console.error('Error while getting member information by Id: ', err.message);
    });
  }

  openStatusModal(id?, targetStatusId?) {
    this.statusModal = this.modalService.show(StatusModalComponent, {class: 'confirm-modal'});
    const isActivate = targetStatusId === 1;
    const isBlock = targetStatusId === 10;
    const message = isActivate
      ? 'Are you sure you want to activate this Member?'
      : (isBlock
        ? 'Are you sure you want to block this Member?'
        : 'Are you sure you want to deactivate this Member?');
    const title = isActivate ? 'Activate Member' : (isBlock ? 'Block Member' : 'Deactivate Member');
    const action1 = isActivate ? 'Activate' : (isBlock ? 'Block' : 'Deactivate');
    const style = isActivate ? 'active' : 'inactive';
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'member',
      title: title,
      message: message,
      status: targetStatusId,
      id: id,
      action1: action1,
      action2: 'Cancel',
      action: '',
      style: style
    };
  }

  confirmClose() {
    this.statusModal = this.modalService.show(StatusModalComponent, {class: 'confirm-modal'});
    this.statusModal.content.srcObject = {
      mode: 'custom',
      type: 'member',
      title: 'Confirm',
      message: !this.memberId ? 'Are you sure you want to cancel adding a new Member?' : 'Do you want to cancel modifying the Member?',
      status: null,
      action1: 'Yes',
      action2: 'No',
      action: '',
    };
  }

  initForm(data?) {
    this.memberForm = this.fb.group({
      loyaltyMemberId: [data ? data.loyaltyMemberId : null],
      genderSuffix: [data ? data.genderSuffix : null, Validators.required], // select dropdown
      firstName: [data ? data.firstName : null, Validators.required], // textbox
      lastName: [data ? data.lastName : null, Validators.required], // textbox
      secondLastName: [data ? data.secondLastName : null], // textbox
      dateOfBirth: [data && data.dateOfBirth ? new Date(data.dateOfBirth) : null, Validators.required], // date picker
      maritalStatus: [data ? data.maritalStatus : null],
      country: [data ? data.country : null], // select dropdown
      email: [data ? data.email : null, Validators.compose([Validators.required])], // textbox
      phoneNumber: [data ? data.phoneNumber : null, Validators.compose([Validators.minLength(8),
        Validators.maxLength(15), Validators.pattern('^(?=.*?[1-9])[0-9.()-]+$')])], // textbox
      documentTypeId: [data ? data.documentTypeId : null], // select dropdown
      documentNumber: [data ? data.documentNumber : null], // textbox
      hobbies: [data ? data.hobbies : null], // textArea
      isPromotions: [data ? data.isPromotions : null], // checkbox

      cardCode: [data ? data.cardCode : null, Validators.required], // textbox
      userName: [data ? data.userName : null], // textbox
      hotelChainId: [data ? data.hotelChainId : null], // select dropdown

      preferredLanguage: [data ? data.preferredLanguage : null, Validators.required], // textbox/dropdown

      origin: [data ? data.origin : null, Validators.required], // select dropdown
      isActive: [data ? data.isActive : null], // checkbox
      cancellationDate: [data ? data.cancellationDate : null], // date picker
      cancellationCause: [data ? data.cancellationCause : null], // textArea
      idPms: [data ? data.idPms : null, Validators.required], // textbox

      hotel: [data ? data.hotel : null], // select dropdown

      social_id: [data ? data.social_id : null], // textbox
      social_token: [data ? data.social_token : null], // textbox

      alternateEmailId: [data ? data.alternateEmailId : null], // textbox

      notes: [data ? data.notes : null], // textArea
      deleted_in_pms: [data ? data.deleted_in_pms : null], // select dropdown
      createdDateStr: [{value: data ? data.createdDateStr : null, disabled: true}, Validators.required], // readonly
      modificationDate: [{value: data ? data.modificationDate : null, disabled: true}], // readonly
      lastAccessDate: [{value: data ? data.lastAccessDate : null, disabled: true}, Validators.required], // readonly
      friends: [{value: data ? data.friends : null, disabled: true}], // readonly
      totalPoints: [{value: data && data.memberPoints ? data.memberPoints.totalPoints : null, disabled: true}], // readonly
      pointsEarned: [{value: data && data.memberPoints ? data.memberPoints.pointsEarned : null, disabled: true}], // readonly
      pointsExpires: [{value: data && data.memberPoints ? data.memberPoints.pointsExpires : null, disabled: true}], // readonly
      transactionHistory: [data ? data.transactionHistory : null], // list to be shown transaction history

      referral: [{value: data ? data.referral : null, disabled: true}], // readonly

      locale: [data ? data.locale : null], // textbox/dropdown
      preferredCurrency: [data ? data.preferredCurrency : null], // dropdown
      promocode: [{value: data ? data.promocode : '', disabled: true}, [Validators.maxLength(10)]], // readonly
    });
  }

  getMemberLookupData() {
    this.hcaMemberService.getLookupDataForMember().subscribe(res => {
      if (res.error === 0) {
        this.memberRulesList = res.responseObj;
      }
    });
  }

  ngOnInit() {
    this.getMemberLookupData();
    this.initForm();
    this.previousRoute = this.utilService.getPreviousRoute;
    if (this.previousRoute.indexOf('/hotel/') > -1) {
      this.memberDetails = this.hcaMemberService.memberDetails;
    } else {
      this.hcaMemberService.memberDetails = null;
      this.memberDetails = null;
    }
    this.route.params.subscribe(params => {
      this.memberId = +params['id']; // (+) converts string 'id' to a number
      this.hcaMemberService.memberId = this.memberId;
      if (this.memberId && !this.memberDetails) {
        this.getMemberDetails(this.memberId);
      } else {
        this.initForm(this.memberDetails);
      }
    });
  }

  addBenefit(b: boolean) {
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/reception/members-management/members-details/members-details.component.ts